import { render, staticRenderFns } from "./ElementsContainerUpper.vue?vue&type=template&id=990b8ac2&scoped=true&"
import script from "./ElementsContainerUpper.vue?vue&type=script&lang=js&"
export * from "./ElementsContainerUpper.vue?vue&type=script&lang=js&"
import style0 from "./ElementsContainerUpper.vue?vue&type=style&index=0&id=990b8ac2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990b8ac2",
  null
  
)

export default component.exports